import { EXTERNAL_URL, LOCAL_STORAGE } from '~/constants';
import { localStorageManager } from '@libs/shared';
import { MemberFilterStatus } from '~/interfaces';
import { StorageKeyManager } from './storage-key';

/**
 * 根据ticket获取公众号二维码
 *
 * @see https://developers.weixin.qq.com/doc/offiaccount/Account_Management/Generating_a_Parametric_QR_Code.html
 * @param ticket
 * @returns 二维码图片的path，可直接使用
 */
export const getOfficialAccountQrCode = (ticket: string) => {
    return `${EXTERNAL_URL.WECHAT_QR_CODE}${encodeURI(ticket)}`;
};

/**
 * 获取成员状态筛选的 local storage
 *
 * @param deptId
 * @param userId
 */
export const getFilterStorage = (deptId: number | null, userId = '') => {
    const storageKey = `${userId}#${LOCAL_STORAGE.MEMBER_STATUS_FILTER}`;
    const record: Record<number, MemberFilterStatus> = localStorageManager.getItemWithMigrate({
        oldKey: storageKey,
        newKey: StorageKeyManager.getMemberStatusFilterKey({
            userId
        }),
        defaultValue: {}
    });

    return record[deptId || 0] || MemberFilterStatus.ALL;
};

/**
 * 设置成员状态筛选的local storage
 *
 * @param deptId
 * @param status
 * @param userId
 */
export const setFilterStorage = (
    deptId: number | null,
    status: MemberFilterStatus,
    userId = ''
) => {
    const storageKey = StorageKeyManager.getMemberStatusFilterKey({
        userId
    });
    const record: Record<number, MemberFilterStatus> = localStorageManager.getItemWithMigrate({
        oldKey: `${userId}#${LOCAL_STORAGE.MEMBER_STATUS_FILTER}`,
        newKey: storageKey,
        defaultValue: {}
    });

    localStorageManager.set(storageKey, {
        ...record,
        // 选择“全部成员”时deptId为 null，按0处理
        [deptId || 0]: status
    });
};
